import React, {Component} from 'react';
import SimpleView from "../../SimpleView/SimpleView";
import Utils from "../../../utils/utils";
import lcService from "../../../services/lcService";
import ProgressBar from "../../ProgressBar/ProgressBar";

class Staff extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            displayLoader: false
        }
    };

    // Update state table data with the received data from the server
    setUpData = (result) => {
        if (result.data) {
            this.setState({
                data: result.data,
                displayLoader: false
            });
        } else {
            Utils.displayMessage('error', 'Failed', result.message).then(r => r);
        }
    };

    componentDidMount() {
        this.setState({
            displayLoader: true
        });
        lcService.loadProgrammes(this.props.match.params.id, this.setUpData);
        if (this.props.history.location.inst_name) {
            localStorage.setItem('inst_name', this.props.history.location.inst_name);
        }
    }

    render() {
        const _instName = this.props.history.location.inst_name;
        const _suffix = " Program List";
        const data = {
            name: (_instName === undefined) ? localStorage.getItem('inst_name') + _suffix : this.props.history.location.inst_name + _suffix,
            headers: [
                {title: 'Name', field: 'name'},
                {title: 'National Name', field: 'national_program_name'},
                {title: 'ISCED Level', field: 'isced_level'},
                {title: 'Duration', field: 'duration'},
                {title: 'Tuition Fee', field: 'tution_fees'},
                {title: 'Entry Requirements', field: 'entry_requirements'},
                {title: 'Female Students', field: 'female_students'},
                {title: 'Male Students', field: 'male_students'}
            ],
            data: this.state.data,
            onlyBackButton: true,
        };
        return (
            <>
                {
                    this.state.displayLoader ? <ProgressBar/> : null
                }
                <div style={{marginTop: 55}}>
                    <SimpleView data={data}/>
                </div>
            </>
        );
    }
}

export default Staff;
